module.exports = __webpack_public_path__ + "static/media/IX.8c1c375b.png";